import { render, staticRenderFns } from "./DisbursementPendingAlert.vue?vue&type=template&id=3478d2ea&"
import script from "./DisbursementPendingAlert.vue?vue&type=script&lang=js&"
export * from "./DisbursementPendingAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports